import React, { useEffect, useRef } from 'react';

import BarChart from '@/pages/dashboard/components/Chart/components/BarChart';
import type { ChartRef, LineChartProps } from '@/pages/dashboard/components/Chart/_config/interface';

/**
 * 竞品趋势：同 ResizeAwareLineChart，仅 competitor 使用。
 */
const ResizeAwareBarChart = (props: LineChartProps) => {
  const chartRef = useRef<ChartRef>(null);
  const { height } = props;

  useEffect(() => {
    if (height === undefined) {
      return;
    }
    const inst = chartRef.current?.instance();
    if (!inst) {
      return;
    }
    inst.resize({ animation: { duration: 300 } });
    const id = requestAnimationFrame(() => {
      inst.resize({ animation: { duration: 300 } });
    });
    return () => cancelAnimationFrame(id);
  }, [height]);

  return <BarChart ref={chartRef} {...props} />;
};

export default ResizeAwareBarChart;
